// --------------------------------------------------------------
// Created On: 2025-05-20
// Author: Zachary Thomas
//
// Last Modified: 2025-05-27
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Returns whether a specific history graph is used for accumulation.
export default function templateGraphIsAccumulative(
  graph: Graph | null,
  historyGraphTypes: HistoryGraphType[]
): boolean {
  if (graph === null) {
    return false;
  } else {
    const selectedHistoryGraphType = historyGraphTypes.find(
      (historyGraphType) => historyGraphType.historyGraphTypeId === graph.historyGraphTypeId
    );
    if (selectedHistoryGraphType === undefined) {
      return false;
    } else {
      const graphTypeName = selectedHistoryGraphType.name.toUpperCase();
      return graphTypeName.includes("ACCUMULATION");
    }
  }
}

interface Graph {
  historyGraphTypeId: number;
  historyGraphAxisTypeId: number;
  isExtraWide: boolean;
  numberOfDaysShown: number | string;
}

interface HistoryGraphType {
  historyGraphTypeId: number;
  name: string;
  description: string;
}
